import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import './App.css';
import "react-toastify/dist/ReactToastify.css";

import { AuthProvider } from "./hooks/useAuth";
import PrivateRoute from "./components/PrivateRoute";
import PublicRoute from "./components/PublicRoute";

import Login from "./pages/Login";
import SignUp from "./pages/SignUp";

import AuthLayout from "./components/layouts/AuthLayout";
import DashboardLayout from "./components/layouts/DashboardLayout";
// import PublicLayout from "./components/layouts/PublicLayout";
import {  ToastContainer } from "react-toastify";
import ProfilePage from "./pages/ProfilePage";
import {  pageRoute, siteData } from "./utils/common";
import NewsletterList from "./pages/NewsletterList";
import ContactUsList from "./pages/ContactUsList";
import JobList from './components/blog/JobList';
import JobAdd from './components/blog/JobAdd';
import JobEdit from './components/blog/JobEdit';
import ChannelManagementPage from "./pages/ChannelManagementPage";
import SliderManagementPage from "./pages/SliderManagementPage";
import MatchDetails from "./pages/MatchDetails";
import WebsiteSettings from "./pages/WebsiteSettings";
function App() {
  
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Auth Pages (Login / Signup) */}
          <Route
        
            element={
              <PublicRoute>
                <AuthLayout />
              </PublicRoute>
            }
          >
            <Route path={pageRoute.login} element={<Login />} />
            <Route path={pageRoute.signUp} element={<SignUp />} />
          </Route>

          {/* Dashboard Pages */}
          <Route
        
            element={
              <PrivateRoute>
                <DashboardLayout />
              </PrivateRoute>
            }
          >
            <Route path={pageRoute.matchDetails} element={<MatchDetails />} />
            <Route path={pageRoute.contactUsList} element={<ContactUsList />} />
            <Route path={pageRoute.channelManagement} element={<ChannelManagementPage />} />
            <Route path={pageRoute.sliderManagement} element={<SliderManagementPage />} />
            <Route path={pageRoute.newsLatter} element={<NewsletterList />} />
            <Route path={pageRoute.profile} element={<ProfilePage />} />
            <Route path={'/blog'} element={<JobList />} />
            <Route path={'/website-settings'} element={<WebsiteSettings />} />
            <Route path={'/blog/add'} element={<JobAdd />} />
            <Route path={'/blog/edit/:jobId'} element={<JobEdit />} />
          </Route>

          {/* Default Redirect */}
          <Route path="*" element={<Navigate to={pageRoute.profile} replace />} />
        </Routes>
      </Router>
      <ToastContainer autoClose={1500} style={{maxWidth:'80%'}}/>
    </AuthProvider>
  );
}

export default App;

